export const NAVIGATION = 100;
export const BANNER = 50;
export const PAGE = 0;
export const FOOTER = 100;
export const DRAWER = 999;
